import useSWR, { SWRResponse } from 'swr';
import { getBalconiesByPropertyId } from '../../../providers/api/balcony/balconyProvider';
import { Balcony } from '../../../providers/api/dtos/balcony';

export const BALCONIES_RID = '/property/:id/balconies';

export default function useBalconies(propertyId?: number): SWRResponse<Balcony[], Error> {
  return useSWR(propertyId ? [BALCONIES_RID, propertyId] : null, () => getBalconiesByPropertyId(propertyId!));
}
